export default __webpack_public_path__ + "static/media/evangelusLogo.0ac83398.svg";